import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationService} from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputMaskModule} from 'primeng/inputmask';


import { CaseComponent } from './case/case.component';
import { CaseApplicantComponent } from './case/case-applicant.component';

import { CaseAgentComponent } from './case/case-agent.component';
import { CasePropertyComponent } from './case/case-property.component';
import { CaseValueComponent } from './case/case-value.component';
import { CaseStatusComponent } from './case/case-status.component';
import { CaseLookupComponent } from './case/case-lookup.component';
import { AgenciesComponent } from './agencies/agencies.component';
import { ApplicantsComponent} from './applicants/applicants.component';
import { CaseMinutesComponent } from './case/case-minutes.component';
import { CaseEFileComponent } from './case/case-efile.component';
import { CaseFactsComponent } from './case/case-facts.component';
import { CaseDocsComponent } from './case/case-docs.component';
import { CaseNewComponent } from './case/new-case.component';
import { CaseAssessorComponent } from './case/case-assessor.component';
import { CaseOldComponent } from './case/old-case.component';

import { EfileImportComponent} from './efile/efile.component';

import { ApplicationCaseDto } from './case/dto/application-case.dto';
import { AgencyDto } from './agencies/agency.dto';
import { ApplicationAssessorDto } from './case/dto/application-assessor.dto';
import { ApplicationMinutesDto } from './case/dto/application-minutes.dto';
import { ApplicationStatusDto } from './case/dto/application-status.dto';
import { ApplicationCaseCommentDto } from './case/dto/application-comments.dto';
import { LoginRouteGuard } from '../login-route-guard';
import { from } from 'rxjs';

import { APNPipe } from 'src/app/shared/custom.pipe';

@NgModule({
    imports: [
        CommonModule,
        AccordionModule,
        TableModule,
        FormsModule,
        ToastModule,
        ConfirmDialogModule,
        MessagesModule,
        CalendarModule,
        FileUploadModule,
        ProgressSpinnerModule,
        InputMaskModule,
        RouterModule.forChild([
          { path: 'caselookup', component: CaseLookupComponent, canActivate: [LoginRouteGuard] },
          { path: 'caselookup/:refreshMode', component: CaseLookupComponent, canActivate: [LoginRouteGuard] },
          { path: 'case', component: CaseComponent, canActivate: [LoginRouteGuard] },
          { path: 'case/:caseid', component: CaseComponent, canActivate: [LoginRouteGuard] },
          { path: 'newcase', component: CaseNewComponent, canActivate: [LoginRouteGuard]},
          { path: 'agencies', component: AgenciesComponent, canActivate: [LoginRouteGuard] },
          { path: 'efiledapps', component: EfileImportComponent, canActivate: [LoginRouteGuard] },
          { path: 'applicants', component: ApplicantsComponent, canActivate: [LoginRouteGuard]},
          { path: 'backload', component: CaseOldComponent, canActivate: [LoginRouteGuard]},
        ]),
    ],
    declarations: [
        CaseComponent,
        CaseApplicantComponent,
        CaseAgentComponent,
        CasePropertyComponent,
        CaseValueComponent,
        CaseStatusComponent,
        CaseLookupComponent,
        AgenciesComponent,
        ApplicantsComponent,
        CaseMinutesComponent,
        CaseEFileComponent,
        EfileImportComponent,
        CaseFactsComponent,
        CaseDocsComponent,
        CaseNewComponent,
        CaseAssessorComponent,
        APNPipe,
        CaseOldComponent,
    ],
    providers: [
        ApplicationCaseDto,
        AgencyDto,
        ApplicationAssessorDto,
        ApplicationMinutesDto,
        ApplicationStatusDto,
        ApplicationCaseCommentDto,
        MessageService,
        ConfirmationService
    ]
})
export class ApplicationModule { }
